export default __webpack_public_path__ + "static/media/9.51b619b3.jpg";